/* NOIRFORM product page: variants, gallery counter, lightbox, sticky add-to-cart. */
(function () {
  'use strict';

  var NF = (window.NF = window.NF || {});
  var theme = window.theme || { strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function ProductSection(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.baseUrl = root.getAttribute('data-product-url');
    this.form = qs('[data-product-form]', root);
    this.picker = qs('[data-variant-picker]', root);
    this.gallery = qs('[data-gallery]', root);
    this.sticky = qs('[data-sticky-atc]', root);
    var json = qs('[data-product-json]', root);
    try { this.product = json ? JSON.parse(json.textContent) : null; } catch (e) { this.product = null; }
    var colorMediaJson = qs('[data-variant-color-media]', root);
    try { this.colorMedia = colorMediaJson ? JSON.parse(colorMediaJson.textContent) : null; } catch (e2) { this.colorMedia = null; }
    this.controller = null;

    this.initVariants();
    this.initGallery();
    this.initSticky();
    this.initTabs();
    this.filterGalleryByColor();
  }

  /* ----- variants ----- */
  ProductSection.prototype.selectedOptions = function () {
    return qsa('[data-option-group]', this.root).map(function (group) {
      var checked = qs('.option__input:checked', group);
      return checked ? checked.value : null;
    });
  };

  ProductSection.prototype.findVariant = function (options) {
    if (!this.product) return null;
    return this.product.variants.filter(function (v) {
      return options.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  };

  ProductSection.prototype.initVariants = function () {
    var self = this;
    if (!this.picker || !this.form) return;
    this.picker.addEventListener('change', function (e) {
      var group = e.target.closest('[data-option-group]');
      if (group) {
        var label = qs('[data-option-selected]', group);
        if (label) label.textContent = e.target.value;
      }
      self.onVariantChange();
    });
  };

  ProductSection.prototype.setUnavailable = function () {
    var self = this;
    var btn = qs('[data-add-to-cart]', this.form);
    var label = qs('[data-add-label]', this.form);
    if (btn) btn.disabled = true;
    if (label) label.textContent = theme.strings.unavailable;
    var sb = qs('[data-sticky-submit]', this.root);
    if (sb) { sb.disabled = true; sb.textContent = theme.strings.unavailable; }
    self.form.classList.add('is-unavailable');
  };

  ProductSection.prototype.onVariantChange = function () {
    var self = this;
    var variant = this.findVariant(this.selectedOptions());
    this.form.classList.remove('is-unavailable');
    if (!variant) { this.setUnavailable(); return; }

    var idInput = qs('[data-variant-id]', this.form);
    if (idInput) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true })); // updates dynamic checkout button
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* noop */ }

    this.filterGalleryByColor();
    if (variant.featured_media && variant.featured_media.id) this.scrollToMedia(variant.featured_media.id);

    // Render fresh price, stock, sku and button state from the server
    if (this.controller && this.controller.abort) this.controller.abort();
    this.controller = 'AbortController' in window ? new AbortController() : null;
    var target = this.baseUrl + (this.baseUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variant.id + '&section_id=' + this.sectionId;
    fetch(target, this.controller ? { signal: this.controller.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-price-wrapper]', '[data-inventory]', '[data-sku]', '[data-sticky-price]'].forEach(function (sel) {
          var fresh = qs(sel, doc), cur = qs(sel, self.root);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        // sold-out marks depend on the other selected options
        var freshItems = doc.querySelectorAll('[data-variant-picker] .option__item');
        self.picker.querySelectorAll('.option__item').forEach(function (item, i) {
          if (freshItems[i]) item.classList.toggle('is-soldout', freshItems[i].classList.contains('is-soldout'));
        });
        var freshBtn = qs('[data-add-to-cart]', doc), curBtn = qs('[data-add-to-cart]', self.form);
        if (freshBtn && curBtn) {
          curBtn.disabled = freshBtn.disabled;
          var fl = qs('[data-add-label]', freshBtn), cl = qs('[data-add-label]', curBtn);
          if (fl && cl) cl.textContent = fl.textContent;
        }
        var freshSticky = qs('[data-sticky-submit]', doc), curSticky = qs('[data-sticky-submit]', self.root);
        if (freshSticky && curSticky) {
          curSticky.disabled = freshSticky.disabled;
          curSticky.textContent = freshSticky.textContent.trim();
        }
        // payment button: remove when unavailable, otherwise leave Shopify's script in charge
        var freshPay = qs('.shopify-payment-button', doc), curPay = qs('.shopify-payment-button', self.form);
        if (curPay && !freshPay) curPay.hidden = true;
        if (curPay && freshPay) curPay.hidden = false;
        document.dispatchEvent(new CustomEvent('nf:variant:change', { detail: { variant: variant, section: self.root } }));
      })
      .catch(function (err) { if (!err || err.name !== 'AbortError') { /* keep current state */ } });
  };

  /* ----- gallery ----- */
  ProductSection.prototype.filterGalleryByColor = function () {
    if (!this.gallery || !this.colorMedia) return;
    var colorGroup = qs('[data-option-group][data-option-color]', this.picker);
    if (!colorGroup) return;
    var checked = qs('.option__input:checked', colorGroup);
    if (!checked) return;
    var idsForColor = (this.colorMedia[checked.value] || '').split(',').filter(Boolean);
    if (!idsForColor.length) return; // nothing mapped for this color, leave gallery as-is

    // Any media id assigned to at least one variant, across all colors
    var allAssigned = {};
    Object.keys(this.colorMedia).forEach(function (key) {
      this.colorMedia[key].split(',').filter(Boolean).forEach(function (id) { allAssigned[id] = true; });
    }, this);

    var colorSet = {};
    idsForColor.forEach(function (id) { colorSet[id] = true; });

    var items = qsa('.gallery__item', this.gallery);
    var firstVisible = null;
    items.forEach(function (item) {
      var id = item.getAttribute('data-media-id');
      var show = !allAssigned[id] || colorSet[id]; // unassigned (shared) photos always show
      item.classList.toggle('is-color-hidden', !show);
      item.hidden = !show;
      if (show && !firstVisible) firstVisible = item;
    });
    // editorial layout pins the first visible photo in its own column
    items.forEach(function (item) { item.classList.toggle('is-lead', item === firstVisible); });
    if (firstVisible && this.gallery.scrollWidth > this.gallery.clientWidth + 4) {
      this.gallery.scrollTo({ left: firstVisible.offsetLeft, behavior: 'auto' });
    }
  };

  ProductSection.prototype.scrollToMedia = function (mediaId) {
    if (!this.gallery) return;
    var item = qs('[data-media-id="' + mediaId + '"]', this.gallery);
    if (!item) return;
    var horizontal = this.gallery.scrollWidth > this.gallery.clientWidth + 4;
    if (horizontal) {
      this.gallery.scrollTo({ left: item.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    } else if (window.matchMedia('(max-width: 989px)').matches) {
      item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    } else {
      var top = item.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80) - 12;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  ProductSection.prototype.initGallery = function () {
    var self = this;
    if (!this.gallery) return;
    var items = qsa('.gallery__item', this.gallery);
    var current = qs('[data-gallery-current]', this.root);

    if (current && items.length > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            current.textContent = parseInt(entry.target.getAttribute('data-index'), 10) + 1;
          }
        });
      }, { threshold: [0.55] });
      items.forEach(function (it) { io.observe(it); });
    }

    this.gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lightbox-open]');
      if (!btn) return;
      var zoomables = qsa('[data-lightbox-open]', self.gallery);
      Lightbox.open(zoomables, zoomables.indexOf(btn));
    });
  };

  /* ----- info tabs ----- */
  ProductSection.prototype.initTabs = function () {
    var wrap = qs('[data-tabs]', this.root);
    if (!wrap) return;
    var tabs = qsa('[role="tab"]', wrap);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    wrap.addEventListener('click', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (tab) select(tab);
    });
    wrap.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      select(next);
      next.focus();
      e.preventDefault();
    });
  };

  /* ----- sticky add to cart ----- */
  ProductSection.prototype.initSticky = function () {
    var self = this;
    if (!this.sticky || !this.form || !('IntersectionObserver' in window)) return;
    var btn = qs('[data-add-to-cart]', this.form);
    if (!btn) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
      self.sticky.classList.toggle('is-visible', pastButton);
      self.sticky.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(btn);

    var submit = qs('[data-sticky-submit]', this.sticky);
    if (submit) {
      submit.addEventListener('click', function () {
        if (submit.disabled) return;
        if (self.form.requestSubmit) {
          var real = qs('[data-add-to-cart]', self.form);
          self.form.requestSubmit(real);
        } else {
          self.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }
  };

  /* ----- lightbox ----- */
  var Lightbox = {
    el: null, items: [], index: 0, lastFocus: null,

    build: function () {
      var el = document.createElement('div');
      el.className = 'lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.innerHTML =
        '<button type="button" class="lightbox__close icon-btn" data-lb-close aria-label="Close">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--prev icon-btn" data-lb-prev aria-label="Previous">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--next icon-btn" data-lb-next aria-label="Next">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<div class="lightbox__stage" data-lb-stage><img class="lightbox__img" alt="" data-lb-img></div>' +
        '<div class="lightbox__count" data-lb-count></div>';
      document.body.appendChild(el);

      var self = this;
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) return self.close();
        if (e.target.closest('[data-lb-prev]')) return self.show(self.index - 1);
        if (e.target.closest('[data-lb-next]')) return self.show(self.index + 1);
        var img = e.target.closest('[data-lb-img]');
        if (img) {
          var zoomed = el.classList.toggle('is-zoomed');
          if (zoomed) {
            var r = img.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          }
          return;
        }
        if (e.target.closest('[data-lb-stage]')) self.close();
      });
      el.addEventListener('mousemove', function (e) {
        if (!el.classList.contains('is-zoomed')) return;
        var img = qs('[data-lb-img]', el), r = img.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        }
      });
      document.addEventListener('keydown', function (e) {
        if (!self.el || !self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.show(self.index - 1);
        if (e.key === 'ArrowRight') self.show(self.index + 1);
      });
      this.el = el;
    },

    show: function (i) {
      var n = this.items.length;
      this.index = (i + n) % n;
      var src = this.items[this.index];
      var img = qs('[data-lb-img]', this.el);
      this.el.classList.remove('is-zoomed');
      img.style.transformOrigin = '';
      img.src = src.getAttribute('data-zoom-src');
      img.alt = src.getAttribute('data-zoom-alt') || '';
      qs('[data-lb-count]', this.el).textContent = (this.index + 1) + ' / ' + n;
      this.el.classList.toggle('lightbox--single', n < 2);
    },

    open: function (items, index) {
      if (!this.el) this.build();
      this.items = items;
      this.lastFocus = document.activeElement;
      this.show(index);
      this.el.classList.add('is-open');
      document.documentElement.classList.add('has-drawer-open');
      qs('[data-lb-close]', this.el).focus();
    },

    close: function () {
      this.el.classList.remove('is-open', 'is-zoomed');
      document.documentElement.classList.remove('has-drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  };

  /* ----- init ----- */
  function init(root) {
    qsa('[data-product-section]', root).forEach(function (el) {
      if (!el.__nfProduct) el.__nfProduct = new ProductSection(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
